import comp from "./CroppableImageDropZone";
export default comp;
